export enum ProcedureViewMode {
  ReadOnly = 0,
  Edit = 1,
  PublishRequest = 2,
  Public = 3
}
